import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { ISituationProfessionnellePresentation } from "../../containers/DossierLocation/SituationProfessionnellePage/helpers";
import { wrapError } from "../../helpers/utils";
import { ActionCreators as PiecesActionCreators } from "../../redux/Pieces";
import { ActionCreators } from "../../redux/SituationProfessionnelle";
import Api, { IApi } from "../../services/Api";
import {
  DossierPiecesId,
  SituationProfessionnelle,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const useGetListSituationProfessionnelles = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useQuery<SituationProfessionnelle[]>(
    "situationProfessionnelleList",
    () => api && api.getListSituationsProfessionnelles(),
    {
      retry: false,
      onSuccess: (data) => {
        dispatch(
          ActionCreators.getListSituationProfessionnelleAsync.success(data)
        );
      },
    }
  );
};

// export function* addUpdateSituationProfessionnelle(
//   api: IApi,
//   action: ActionType<
//     typeof ActionCreators.addOrUpdateSituationProfessionnelleAsync.request
//   >
// ) {
//   try {
// const { principal, secondaire } = action.payload;
// const situationPersonnelle: Types.SituationPersonnelleData = yield select(
//   SituationPersonnelleSelector.getSituationPersonnelle
// );

// // récupération de la référence du dossier
// const refDossierLocation: string = yield select(
//   DossierLocationSelector.getSelectedDossier
// ) || "";

// // récupération de la référence de la personne
// const refDossierParticulierPrincipal =
//   principal.reference ||
//   (situationPersonnelle &&
//     situationPersonnelle.situationPrincipale &&
//     situationPersonnelle.situationPrincipale.reference) ||
//   "";
// if (
//   principal &&
//   (principal.statut === "INCOMPLET" ||
//     principal.statut === "BLOQUE" ||
//     principal.statut === "")
// ) {
//   yield* addUpdateSituationProfessionnelleUnitaire(
//     api,
//     principal,
//     refDossierLocation,
//     refDossierParticulierPrincipal,
//     "principal"
//   );
// }

// if (
//   secondaire &&
//   (secondaire.statut === "INCOMPLET" ||
//     secondaire.statut === "BLOQUE" ||
//     secondaire.statut === "")
// ) {
//   const refDossierParticulierSecondaire =
//     secondaire.reference ||
//     (situationPersonnelle &&
//       situationPersonnelle.situationConjoint &&
//       situationPersonnelle.situationConjoint.reference) ||
//     "";

//   yield* addUpdateSituationProfessionnelleUnitaire(
//     api,
//     secondaire,
//     refDossierLocation,
//     refDossierParticulierSecondaire,
//     "secondaire"
//   );
// }

//     yield put(
//       ActionCreators.addOrUpdateSituationProfessionnelleAsync.success(
//         action.payload
//       )
//     );
//     // vérification si partenaire contrôle les pièces justificatives
//     const isControleDossier: boolean = yield select(
//       PartenaireSelector.getControleDossier
//     );
//     if (isControleDossier) {
//       yield put(push("/dossier-location/pieces-justificatives"));
//     } else {
//       yield put(push("/dossier-location/synthese"));
//     }
//   } catch (error) {
//     yield put(stopSubmit("situationProfessionnelleForm", error.content));
//     yield put(
//       ActionCreators.addOrUpdateSituationProfessionnelleAsync.failure(error)
//     );
//   }
// }

export const usePutSituationProfessionnelleUnitaire = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  return useMutation<
    ISituationProfessionnellePresentation,
    any,
    {
      dossierLocationRef?: string;
      dossierParticulierRef: string;
      situationProfessionnelle: ISituationProfessionnellePresentation;
      prefixe: "principal" | "secondaire";
    }
  >(
    // @ts-ignore
    (params: {
      dossierLocationRef?: string;
      dossierParticulierRef: string;
      situationProfessionnelle: ISituationProfessionnellePresentation;
      prefixe: "principal" | "secondaire";
    }) =>
      (api &&
        params.dossierLocationRef &&
        api.putSituationProfessionnelle({
          dossierLocationRef: params.dossierLocationRef,
          dossierParticulierRef: params.dossierParticulierRef,
          situationProfessionnelle: params.situationProfessionnelle,
        })) ||
      undefined,
    {
      onSuccess: (data: DossierPiecesId, variables) => {
        if (
          data.parcoursNetheos != null &&
          data.parcoursNetheos.startsWith("CO")
        ) {
          dispatch(PiecesActionCreators.saveTokenConjointNetheos(data));
        } else {
          dispatch(PiecesActionCreators.saveTokenNetheos(data));
        }
      },
    }
  );
};
